import { Component, Inject, OnInit } from '@angular/core';
import { BaseComponent } from '@core/base.component';
import { MatterFileType } from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import {
	AnalyticsEvent,
	AnalyticsService,
} from '@services/analytics/analytics.service';
import { NavigationService } from '@services/nav/nav.service';
import { UrlService } from '@services/url/url.service';
import { TrustLedgerSelectors } from '@state/global/trust-ledger/trust_ledger';
import {
	LedgerItemType,
	TrustLedgerItem,
} from '@state/global/trust-ledger/trust_ledger.models';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Observable } from 'rxjs/internal/Observable';
import { DRAWER_DATA } from 'src/app/ui/drawer/drawer-data.token';

export interface VM {
	trustLedgerItem: TrustLedgerItem;
}

export const defaultVM: VM = {
	trustLedgerItem: null,
};

@UntilDestroy()
@Component({
	selector: 'app-sale-price-item-drawer',
	templateUrl: './sale-price-item-drawer.component.html',
	styleUrls: ['./sale-price-item-drawer.component.scss'],
	standalone: false,
})
export class SalePriceItemDrawerComponent
	extends BaseComponent<VM>
	implements OnInit
{
	@Select(TrustLedgerSelectors.getTrustLedgerSalePriceItem)
	trustLedgerItem$: Observable<TrustLedgerItem>;

	@SelectSnapshot(SelectedMatter.matterFileType) matterFileType: string;
	@SelectSnapshot(SelectedMatter.overrideAdjustments)
	overrideAdjustments: boolean;

	backUrlParams = { 'back-string': 'trust ledger' };

	description: string;
	trustLedgerItem: TrustLedgerItem;
	originalTitle: string;

	private matterId: string;

	constructor(
		@Inject(DRAWER_DATA)
		public data: {
			matterId: string;
			trustLedgerItem: TrustLedgerItem;
		},
		private matterDispatch: MatterDispatch,
		private navService: NavigationService,
		private analytics: AnalyticsService,
	) {
		super(defaultVM);
	}

	ngOnInit(): void {
		this.trustLedgerItem$
			.pipe(untilDestroyed(this))
			.subscribe((trustLedgerItem) => {
				this.VM = {
					trustLedgerItem: trustLedgerItem,
				};
			});
		this.matterId = this.data.matterId;
		this.trustLedgerItem = this.data.trustLedgerItem;
		this.description = this.data.trustLedgerItem.description;
		this.originalTitle = this.data.trustLedgerItem.description;
	}

	updateDescription(description: string) {
		this.description = description;
		if (this.matterFileType === MatterFileType.SALE) {
			this.matterDispatch.SetReceiptDescriptionOverride(
				this.matterId,
				this.trustLedgerItem.id,
				this.description,
			);
		} else if (this.matterFileType === MatterFileType.PURCHASE) {
			this.matterDispatch.SetPaymentDescriptionOverride(
				this.matterId,
				this.trustLedgerItem.id,
				this.description,
			);
		}
	}

	goToItem(trustLedgerItem: TrustLedgerItem) {
		this.analytics.logEvent(
			AnalyticsEvent.SALE_PRICE_ITEM_DRAWER_VIEW_SALE_PRICE_LINK_CLICK,
		);
		if (trustLedgerItem.type === LedgerItemType.SALE_PRICE) {
			const url = UrlService.Matter_Adjustments(this.matterId);
			this.navService.goToUrl(url, { ...this.backUrlParams });
		}
	}
}
